(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsHome = this.header && this.header.classList.contains('is-home');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky && !this.headerIsHome) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.headerIsHome) {
        this.updateHomeHeaderState();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observerInstance) => {
        this.headerBounds = entries[0].intersectionRect;
        observerInstance.disconnect();
      });

      observer.observe(this.header);
    }

    updateHomeHeaderState() {
      if (!this.headerIsHome) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 20) {
        this.header.classList.add('scrolled-past-header');
      } else {
        this.header.classList.remove('scrolled-past-header');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isMobileHeader = window.matchMedia('(max-width: 749px)').matches;
      const isTouchHeader = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
      const shouldStabilizeHeader = isMobileHeader || isTouchHeader;

      if (Array.from(this.predictiveSearches).some((predictiveSearch) => predictiveSearch.isOpen)) return;

      /*
        Mobile/tablet fix:
        Op touch-devices schakelen we Dawn's hide/reveal gedrag uit.
        Daardoor kan de header niet meer ineens wegvallen of te hoog komen te staan
        bij snel scrollen of wanneer de mobiele/tablet browserbalk beweegt.
      */
      if (shouldStabilizeHeader) {
        this.header.classList.remove('shopify-section-header-hidden', 'animate');

        if (this.headerIsHome) {
          this.updateHomeHeaderState();
        } else {
          this.header.classList.add('shopify-section-header-sticky');

          if (scrollTop > 2) {
            this.header.classList.add('scrolled-past-header');
          } else {
            this.header.classList.remove('scrolled-past-header');
          }
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (this.headerIsHome) {
        this.updateHomeHeaderState();
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const updateMobileViewportHeight = () => {
      const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

      document.documentElement.style.setProperty('--hanami-mobile-vh', `${viewportHeight}px`);
    };

    updateMobileViewportHeight();
    window.addEventListener('resize', updateMobileViewportHeight, { passive: true });
    window.addEventListener('orientationchange', updateMobileViewportHeight);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateMobileViewportHeight, { passive: true });
      window.visualViewport.addEventListener('scroll', updateMobileViewportHeight, { passive: true });
    }

    const homeHeader = document.querySelector('.section-header.is-home');

    if (homeHeader) {
      const updateHeader = () => {
        if (window.scrollY > 20) {
          homeHeader.classList.add('scrolled-past-header');
        } else {
          homeHeader.classList.remove('scrolled-past-header');
        }
      };

      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
    }

    const drawer = document.querySelector('#menu-drawer');
    const drawerSearch = drawer ? drawer.querySelector('[data-hanami-drawer-search]') : null;

    if (drawerSearch && drawer) {
      const drawerDetails = drawer.closest('details');
      const navigation = drawer.querySelector('.menu-drawer__navigation');
      const navigationContainer =
        drawer.querySelector('.menu-drawer__navigation-container') ||
        drawer.querySelector('.menu-drawer__inner-container') ||
        null;
      const form = drawerSearch.querySelector('form');
      const input = drawerSearch.querySelector('input[type="search"]');
      const predictiveSearch = drawerSearch.querySelector('predictive-search');

      const setDrawerSearchMode = (isActive) => {
        const hasValue = Boolean(input && input.value.trim().length > 0);
        const drawerIsOpen = Boolean(drawerDetails && drawerDetails.open);
        const nextState = Boolean(isActive && hasValue && drawerIsOpen && predictiveSearch);

        if (navigation) {
          navigation.classList.toggle('hanami-drawer-search-active', nextState);
        }

        if (navigationContainer) {
          navigationContainer.classList.toggle('hanami-drawer-search-active', nextState);
        }

        drawer.classList.toggle('hanami-drawer-search-active', nextState);
        drawerSearch.classList.toggle('hanami-mobile-drawer-search--active', nextState);
        drawerSearch.classList.toggle('hanami-mobile-drawer-search--has-value', hasValue);
        document.documentElement.classList.toggle('hanami-drawer-search-open', nextState);

        const sectionHeader = document.querySelector('.section-header');
        if (sectionHeader && nextState) {
          sectionHeader.classList.remove('shopify-section-header-hidden', 'animate');
          sectionHeader.classList.add('shopify-section-header-sticky');
        }
      };

      const updateDrawerSearchMode = () => {
        setDrawerSearchMode(true);
      };

      const clearDrawerSearch = ({ restoreFocus = false } = {}) => {
        if (!input) return;

        if (predictiveSearch && typeof predictiveSearch.close === 'function') {
          predictiveSearch.close(true);
        } else {
          input.value = '';
        }

        drawerSearch.classList.remove('hanami-mobile-drawer-search--has-value');
        setDrawerSearchMode(false);

        if (restoreFocus && drawerDetails && drawerDetails.open) {
          window.requestAnimationFrame(() => input.focus());
        } else {
          input.blur();
        }
      };

      if (input) {
        updateDrawerSearchMode();

        input.addEventListener('input', updateDrawerSearchMode);

        input.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && input.value.length > 0) {
            event.preventDefault();
            clearDrawerSearch({ restoreFocus: true });
          }
        });

        if (form) {
          form.addEventListener('reset', () => {
            window.requestAnimationFrame(() => {
              input.value = '';
              drawerSearch.classList.remove('hanami-mobile-drawer-search--has-value');
              setDrawerSearchMode(false);
            });
          });
        }

        if (drawerDetails) {
          drawerDetails.addEventListener('toggle', () => {
            if (!drawerDetails.open) {
              clearDrawerSearch();
            } else {
              updateDrawerSearchMode();
            }
          });
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
